/* @ngInject */
function AuditSocialMediaPostsController ($rootScope, $scope, $timeout, $attrs, SocialMediaService, ToastService) {
  $scope.flags = {
    loading: false,
    seenPosts: {
      top: 20,
      skip: 0,
      loading: false,
      hasMoreResults: false,
      showMoreButton: true
    },
    notSeenPosts: {
      top: 20,
      skip: 0,
      loading: false,
      hasMoreResults: false
    }
  }

  $scope.seenPosts = []
  $scope.notSeenPosts = []

  const api = {
    _getAllPosts,
    _getPosts,
    _addAssetUrlToPosts,
    _mountPosts,
    _getTopAndSkip,
    _hasMoreResults,
    _initObserverShowMore,
    _verifyIntersectionButton
  }

  this.getApi = () => api

  activate()

  function activate () {}

  const deregisterRemovePosts = $rootScope.$on('socialMedia.removePosts', () => {
    $scope.flags.seenPosts.skip = 0
    $scope.flags.notSeenPosts.skip = 0
    api._getAllPosts()
  })

  const deregisterFiltersWatcher = $scope.$watchCollection('filters', () => {
    api._getAllPosts()
  })

  const deregisterReloadPosts = $rootScope.$on('audit-social-media-reload-posts', () => {
    $scope.flags.seenPosts.skip = 0
    $scope.flags.notSeenPosts.skip = 0
    api._getAllPosts()
  })

  $scope.$on('$destroy', () => {
    deregisterRemovePosts()
    deregisterFiltersWatcher()
    deregisterReloadPosts()
  })

  $scope.handleLoadMorePosts = (alreadySeen = false) => {
    const loadMore = true
    api._getPosts(alreadySeen, loadMore)
  }

  function _getAllPosts () {
    api._getPosts(true)
    api._getPosts()
  }

  async function _getPosts (alreadySeen = false, loadMore = false) {
    if (!loadMore) {
      $scope.flags.loading = true
      $scope.flags.seenPosts.skip = 0
      $scope.flags.notSeenPosts.skip = 0
    }

    const socialType = 'instagram'
    const filters = $scope.filters

    const params = {
      alreadySeen,
      accountIds: filters?.accounts,
      groupIds: filters?.groups,
      type: filters?.contentType,
      start: filters?.date?.start,
      end: filters?.date?.end,
      nonConformity: filters?.nonConformity?.value
    }

    const { top, skip } = api._getTopAndSkip(alreadySeen, loadMore)

    try {
      const response = await SocialMediaService.getContents(socialType, top, skip, params)

      const rows = response.rows
      const count = response.count
      const posts = api._addAssetUrlToPosts(socialType, rows)

      api._mountPosts(alreadySeen, loadMore, posts, count)
    } catch (err) {
      ToastService.defaultErrorToast()
      console.error(err)
    } finally {
      $timeout(() => {
        $scope.flags.loading = false
        $scope.flags.seenPosts.loading = false
        $scope.flags.notSeenPosts.loading = false
      })
    }
  }

  function _addAssetUrlToPosts (socialType, posts) {
    return posts.map(post => ({
      ...post,
      assetUrl: SocialMediaService.getContentAsset(socialType, post.id)
    }))
  }

  function _mountPosts (alreadySeen, loadMore, posts, count) {
    if (alreadySeen) {
      $scope.seenPosts = loadMore ? [...$scope.seenPosts, ...posts] : posts

      const postsLength = $scope.seenPosts.length
      $scope.flags.seenPosts.hasMoreResults = api._hasMoreResults(count, postsLength)
    } else {
      $scope.notSeenPosts = loadMore ? [...$scope.notSeenPosts, ...posts] : posts

      const postsLength = $scope.notSeenPosts.length
      $scope.flags.notSeenPosts.hasMoreResults = api._hasMoreResults(count, postsLength)
    }

    if ($scope.notSeenPosts.length && $scope.flags.notSeenPosts.hasMoreResults) {
      $scope.flags.seenPosts.showMoreButton = false
    } else {
      $scope.flags.seenPosts.showMoreButton = true
    }

    $timeout(() => {
      if (!loadMore) {
        api._initObserverShowMore(alreadySeen)
      }
    }, 300, false)
  }

  function _getTopAndSkip (alreadySeen, loadMore) {
    if (alreadySeen) {
      if (loadMore) {
        $scope.flags.seenPosts.loading = true
        $scope.flags.seenPosts.skip = $scope.flags.seenPosts.top + $scope.flags.seenPosts.skip
      }

      return {
        top: $scope.flags.seenPosts.top,
        skip: $scope.flags.seenPosts.skip
      }
    }

    if (loadMore) {
      $scope.flags.notSeenPosts.loading = true
      $scope.flags.notSeenPosts.skip = $scope.flags.notSeenPosts.top + $scope.flags.notSeenPosts.skip
    }

    return {
      top: $scope.flags.notSeenPosts.top,
      skip: $scope.flags.notSeenPosts.skip
    }
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return totalCount > responseLength
  }

  function _initObserverShowMore (alreadySeen) {
    const elements = {
      seenPosts: $attrs.$$element.find('.button-load-more__seenPosts'),
      notSeenPosts: $attrs.$$element.find('.button-load-more__notSeenPosts')
    }

    const showMoreButton = alreadySeen ? elements.seenPosts : elements.notSeenPosts

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4
    }

    const observer = new IntersectionObserver(([entry]) => {
      api._verifyIntersectionButton(entry, alreadySeen)
    }, options)

    if (showMoreButton[0]) {
      observer.observe(showMoreButton[0])
    }
  }

  function _verifyIntersectionButton (entry, alreadySeen) {
    const hasMoreResults = alreadySeen ? $scope.flags.seenPosts.hasMoreResults : $scope.flags.notSeenPosts.hasMoreResults
    const isNotLoading = alreadySeen ? !$scope.flags.seenPosts.loading : !$scope.flags.notSeenPosts.loading
    const isIntersecting = entry.isIntersecting && entry.intersectionRatio >= 0.4

    if (isIntersecting && hasMoreResults && isNotLoading) {
      $timeout(() => {
        $scope.handleLoadMorePosts(alreadySeen)
      }, 0, true)
    }
  }
}

export { AuditSocialMediaPostsController }
